<template>
  <div id="file-outgoing-container">
    <!-- 上传标题 -->
    <mtd-row>
      <mtd-col :span="24">
        <span class="dd-page-title">文件外发</span>
      </mtd-col>
    </mtd-row>
    <!-- 上传辅标题 -->
    <mtd-row style="margin-top: 16px;height: 22px;">
      <mtd-col :span="24">
        <span class="dd-page-subtitle">上传文件</span>
      </mtd-col>
    </mtd-row>
    <!-- 文件列表显示 -->
    <mtd-row style="margin-top: 4px" :gutter="8" v-if="file_list.length !== 0">
      <mtd-col :span="6" style="margin-top: 8px;" v-for="(item, index) in file_list"
               v-bind:class="{ 'padding-left-0': index%4===0, 'padding-right-0': index%4===3 }">
        <div class="file-item-block">
          <div class="file-type-icon"><img :src="require('@/assets/'+pictureSelect(item)+'.png')"></div>
          <div class="progress-status-container">
            <div class="file-name-div">{{ item.fileName }}</div>
            <div class="progress-div" :class="[upload_status_class(item)]">
              <mtd-icon name='bolt-fill'></mtd-icon>
              <mtd-progress :percentage="item.percentage" :stroke-width="4" class="file-upload-progress"/>
              <div class="file-upload-show-text">
                <span>{{ item.message }}</span>
              </div>
            </div>
          </div>
        </div>
      </mtd-col>
    </mtd-row>
    <!-- 链接有效期 -->
    <mtd-row style="margin-top: 32px">
      <mtd-col :span="24">
        <span class="dd-page-subtitle">选择链接有效期</span>
        <span class="page-info-detail"><i class="mtdicon mtdicon-info-circle-o"/>审批通过后，有效期生效，最长有效期为30天</span>
      </mtd-col>
    </mtd-row>
    <mtd-row style="margin-top: 12px">
      <mtd-col :span="24">
        <mtd-form :label-width="54">
          <mtd-form-item label="有效期" style="margin-bottom: 0;">
            <mtd-select v-model="validateDays" style="width: 120px" @change="validateDays_change">
              <mtd-option :value="day.value" :label="day.label" :key="'key_'+day.value" v-for="day in default_days"/>
              <mtd-option :value="-1" label="自定义"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-form>
      </mtd-col>
    </mtd-row>
    <!-- 外发信息 -->
    <mtd-row style="margin-top: 27px">
      <mtd-col :span="24">
        <span class="dd-page-subtitle">确认外发信息</span>
      </mtd-col>
    </mtd-row>
    <!-- 审批节点 -->
    <mtd-row style="margin-top: 12px" v-if="strategy_chain_list.length > 0">
      <mtd-col :span="24">
        <span>外发审批节点预览</span>
      </mtd-col>
      <mtd-col :span="24">
        <mtd-steps>
          <mtd-step :title="item" v-for="item in strategy_chain_list"/>
        </mtd-steps>
      </mtd-col>
    </mtd-row>
    <!-- 外发原因 -->
    <mtd-row style="margin-top: 12px">
      <mtd-col :span="24">
        <mtd-form label-position="top">
          <mtd-form-item label="" style="margin-bottom: 0;">
            <mtd-textarea v-model="outReason" placeholder="外发原因" style="width: 100%;resize: none; height: 60px;"/>
          </mtd-form-item>
        </mtd-form>
      </mtd-col>
    </mtd-row>
    <!-- 收件人邮箱 -->
    <mtd-row style="margin-top: 32px">
      <mtd-col>
        <mtd-checkbox v-model="email_auto_collapse">
          <span class="dd-page-subtitle">收件人邮箱(选填)</span>
        </mtd-checkbox>
        <span class="page-info-detail"><i class="mtdicon mtdicon-info-circle-o"/>审批通过后，文件下载的链接将自动发送到填写的邮箱</span>
      </mtd-col>
    </mtd-row>
    <mtd-row style="margin-top: 12px" v-if="email_auto_collapse">
      <mtd-col>
        <el-select v-model="email_list" multiple filterable allow-create style="width: 100%;border-radius: 4px"
                   default-first-option placeholder="请输入邮箱">
        </el-select>
      </mtd-col>
    </mtd-row>
    <!-- 底部提交按钮 -->
    <mtd-row class="submit-buttons-div">
      <mtd-col :span="24">
        <mtd-button style="margin-right: 8px" size="large" @click="back_to_file_out">修改外发文件</mtd-button>
        <mtd-button type="primary" size="large" style="margin-left: 8px" @click="submit_out"
                    :disabled="check_file_list">
          申请外发
        </mtd-button>
      </mtd-col>
    </mtd-row>
    <!-- 自定义有效期 -->
    <mtd-modal title="自定义有效期" v-model="custom_validate_modal" width="400px">
      <mtd-form :rules="custom_validate_rule" :model="custom_form">
        <mtd-form-item label="有效期:" prop="custom_validate" :label-width="74">
          <mtd-input type="text" v-model="custom_form.custom_validate" style="width: 240px;"
                     placeholder="请输入1～30以内的数字"/>
          天
        </mtd-form-item>
      </mtd-form>
      <div slot="footer" class="demo-modal-footer">
        <mtd-button @click="close_custom_validate">取消</mtd-button>
        <mtd-button type="primary" @click="submit_custom_validate" :disabled="custom_validate_disabled">确定
        </mtd-button>
      </div>
    </mtd-modal>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "file_out_upload",
  data() {
    const validateCustomDays = (_rule, value, callback) => {
      if (!/^[0-9]*$/.test(value)) {
        return callback(new Error('最长有效期为30天，请输入1-30以内的数字'));
      }
      if (value < 1 || value > 30) {
        return callback(new Error('最长有效期为30天，请输入1-30以内的数字'));
      }
      return callback();
    }
    return {
      default_days: [
        {value: 3, label: '3天'},
        {value: 7, label: '7天'},
        {value: 30, label: '30天'}
      ],
      file_list: [],
      max_limit: 15,
      email_list: [],
      email_auto_collapse: null,
      client_apply_ICP: null,
      outReason: null,
      validateDays: 3,
      custom_form: {
        custom_validate: null,
      },
      custom_validate_modal: false,
      custom_validate_rule: {
        custom_validate: [
          {validator: validateCustomDays, trigger: 'change'},
        ]
      },
      exempt_approval_flag: false,
      matching_strategy_result: null,
      strategy_chain_list: [],
    }
  },
  mounted() {
    // 获取参数
    let {file_list, ICP} = this.$route.query;
    this.client_apply_ICP = ICP;
    if (file_list && file_list !== '') {
      this.query_file_info_list(file_list)
    } else {
      let next_file_list = this.$route.params.file_list;
      this.file_list = next_file_list
    }

  },
  computed: {
    check_file_list() {
      if (this.file_list.length <= 0) {
        return true;
      }
      if (!this.outReason || this.outReason === '') {
        return true;
      }
      for (let i = 0; i < this.file_list.length; i++) {
        if (this.file_list[i].fileStatus !== 'success') {
          return true;
        }
      }
      return false;
    },
    custom_validate_disabled() {
      if (!this.custom_form.custom_validate) {
        return true;
      }
      let custom_validate = parseInt(this.custom_form.custom_validate);
      if (custom_validate < 1 || custom_validate > 30) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions([
      'fileContentScan',
      'matchingStrategy',
      'submitFileOutOrderExemption',
      'query_bpm_approval_chain',
      'submitFileOutOrder',
      'queryFileInfoList'
    ]),
    details() {
      window.open("https://km.sankuai.com/page/18283035");
    },
    query_file_info_list(id_list) {
      this.queryFileInfoList({idList: id_list}).then((res) => {
        let data = res.data;
        let file_list = [];
        data.forEach((item) => {
          file_list.push({
            id: item.id,
            fileName: item.fileName,
            type: item.fileType,
            fileStatus: 'analysis',
            percentage: 100,
            fileSize: item.fileSize,
            uid: item.id,
            message: '上传完成',
            fileGrade: item.secretGrade
          })
        });
        this.file_list = file_list;
        // 扫描文件
        this.handleUploadSuccess();
      });
    },
    handleUploadSuccess() {
      for (let i = 0; i < this.file_list.length; i++) {
        let file = this.file_list[i];
        file.message = '分析中...';
        this.file_scan(file);
      }
    },
    // 文件扫描
    async file_scan(file) {
      let {id, fileName} = file;
      let param = {id: id, fileName: fileName};
      this.fileContentScan(param).then((res) => {
        file.message = '分析完成';
        file.fileStatus = 'success';
        file.sourceFileName = res.data.sourceFileName;
        // 分析完成之后，请求策略匹配
        this.start_matching_strategy();
      }).catch((err) => {
        console.log(err);
        file.message = '分析失败';
        file.fileStatus = 'error';
      });
    },
    back_to_file_out() {
      this.$router.push({name: 'file|client_outer|modify_file_upload'});
    },
    start_matching_strategy() {
      if (!this.file_list || this.file_list.length === 0) {
        this.reset_strategy_data();
        return;
      }
      // 如果其中有一个文件没有成功，就不能进行规则匹配
      for (let i = 0; i < this.file_list.length; i++) {
        let temp = this.file_list[i];
        if (temp.fileStatus !== 'success') {
          return;
        }
      }
      // 匹配策略
      this.matchingStrategy(this.file_list).then(res => {
        let emails = this.email_list.join(",");
        console.log(emails)
        // 如果有报错，提示报错信息
        if (res.code !== 0) {
          console.error(res);
          this.$mtd.message.error(res.message);
          return;
        }
        // 返回数据
        let result = res.data;
        if (result == null) {
          this.matching_strategy_result = null;
          this.exempt_approval_flag = false;
          this.strategy_chain_list = [];
          return;
        }
        // 判断是否是免审批
        let {currentStrategy, isExemption} = result;
        if (!currentStrategy || currentStrategy.isExemption || isExemption) {
          this.exempt_approval_flag = true;
          this.strategy_chain_list = [];
          return;
        }
        // 返回数据不为空，需要添加审批流程
        this.matching_strategy_result = currentStrategy;
        this.exempt_approval_flag = false;
        // 加载所需要的审批链
        this.load_approval_chain();
      });
    },
    load_approval_chain() {
      // 去掉免审批场景
      if (this.exempt_approval_flag || !this.matching_strategy_result) {
        return;
      }
      let strategyId = this.matching_strategy_result.id;
      this.query_bpm_approval_chain({strategyId}).then((res) => {
        if (res.code !== 0) {
          console.error(res);
          this.$mtd.message.error(res.message);
          return;
        }
        this.strategy_chain_list = res.data;
      });
    },
    reset_strategy_data() {
      this.matching_strategy_result = null;
      this.exempt_approval_flag = false;
      this.strategy_chain_list = [];
    },
    submit_out() {
      let emails = this.email_list.join(",");
      let submitParams = {
        emails,
        files: this.file_list,
        fileOutReason: this.outReason,
        validateDays: this.validateDays,
        clientApplyIcp: this.client_apply_ICP
      }
      // 免审批的场景
      if (this.exempt_approval_flag || !this.matching_strategy_result) {
        this.submitFileOutOrderExemption(submitParams).then(res => {
          this.submit_success_redirect(res, emails);
        });
      } else {
        // 下面是需要审批的场景
        submitParams['id'] = this.matching_strategy_result.id;
        submitParams['strategyName'] = this.matching_strategy_result.strategyName;
        this.submitFileOutOrder(submitParams).then(res => {
          this.submit_success_redirect(res, emails);
        });
      }
    },
    submit_success_redirect(res, emails) {
      if (!res || res.code !== 0) {
        console.error(res);
        this.$mtd.message.error("提交失败");
        return;
      }
      let shared = res.data;
      if (shared && shared.url) {
        let info = `文件分享链接： ${shared.url} \n提取密码：${shared.password}`;
        console.log(info);
      }
      this.$router.push({name: 'file|client_outer|file_out_completed', params: {shared, emails}});
    },
    pictureSelect(file) {
      let fileName = file.fileName;
      if (!fileName || fileName === '') {
        return 'usual';
      }
      let temp = fileName.split('.');
      if (!temp || temp.length === 0) {
        return 'usual';
      }
      let fileType = temp[temp.length - 1].toLowerCase();
      switch (fileType) {
        // 表格
        case 'xlsx':
        case 'xls':
          return 'excel';
        // word
        case 'doc':
        case 'docx':
          return 'word';
        // 压缩包
        case 'zip':
          return 'zip';
        // ppt
        case 'ppt':
        case 'pptx':
          return 'ppt';
        // pdf
        case 'pdf':
          return 'pdf';
        // 视频
        case 'avi':
        case 'mpg':
        case 'wmv':
        case 'mov':
        case 'mp4':
          return 'video';
        // 音频
        case 'mp3':
        case 'wma':
          return 'music';
        // 图片
        case 'png':
        case 'gif':
        case 'jpg':
        case 'jpeg':
          return 'picture';
        // 图片素材
        case 'psd':
          return 'PS';
        // 图片素材
        case 'sketch':
          return 'sketch';
        // numbers
        case 'numbers':
          return 'numbers';
        // keynote
        case 'keynote':
          return 'keynote';
        // ai
        case 'ai':
          return 'AI';
        default:
          return 'usual'
      }
    },
    upload_status_class(item) {
      if (item.fileStatus === 'success') {
        return 'upload-result-success'
      } else if (item.fileStatus === 'fail') {
        return 'upload-result-fail'
      } else {
        return 'upload-result-default'
      }
    },
    validateDays_change(val) {
      if (val === -1) {
        this.custom_validate_modal = true;
      } else {
        this.custom_validate_modal = false;
      }
    },
    close_custom_validate() {
      this.custom_validate_modal = false;
      this.custom_form.custom_validate = null;
      this.validateDays = 3;
    },
    submit_custom_validate() {
      let insert = true;
      let custom_validate = this.custom_form.custom_validate;
      for (let i = 0; i < this.default_days.length; i++) {
        let tmp = this.default_days[i];
        if (tmp.value === custom_validate) {
          insert = false;
          break;
        }
      }
      if (insert) {
        this.default_days.push({value: custom_validate, label: custom_validate + '天'});
        this.validateDays = custom_validate;
      }
      this.custom_validate_modal = false;
      this.custom_form.custom_validate = null;
    }
  }
}
</script>

<style>

#file-outgoing-container {
  margin: 16px 24px;
  margin-bottom: 80px;
}

.padding-left-0 {
  padding-left: 0 !important;
}

.padding-right-0 {
  padding-right: 0 !important;
}

.margin-bottom-0 {
  margin-bottom: 0;
}

.dd-page-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0.5px;
  line-height: 32px;
  font-weight: 500;
}

.dd-page-subtitle {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 22px;
  font-weight: 500;
}

.page-info-detail {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.36);
  line-height: 20px;
  font-weight: 400;
  margin-left: 10px;
}

h2.file-list-title {
  font-size: 16px;
  margin-bottom: 16px;
}

.mtd-progress .mtd-progress-percentage {
  display: none;
}

.mtd-progress .mtd-progress-bar {
  padding-right: 0;
  margin-right: 0;
  margin-bottom: 3px;
}

.icon-btn {
  font-size: 16px;
  margin-right: 8px;
  float: right;
  padding: 0;
}

.icon-file-name {
  width: 100%;
  height: 32px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 22px;
  position: absolute;
  top: 12px;
  flex-direction: row;
}

.mtd-icon-btn {
  width: 22px;
  height: 22px;
}

.margin-top-20 {
  height: 100%;
  top: -50px;
}

.full-height-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.result-success {
  border-color: #00B365;
}

.result-fail {
  border-color: #F5483B;
}

.mtd-upload-dragger {
  height: 136px;
}

.upload-content {
  height: 136px;
}

.upload-content .mtd-upload-text .title-text {
  margin-top: 32px;
  margin-bottom: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.60);
  line-height: 22px;
  font-weight: 400;
}

.upload-content .mtd-upload-text .tips {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.36);
  text-align: center;
  line-height: 17px;
  font-weight: 400;
}

.mtd-upload-dragger {
  display: flex;
  justify-content: center;
  align-items: center;
}


.mtd-message {
  min-width: 20px;
  padding: 6px 16px;
}

.el-input__inner {
  border-radius: 4px;
}


.file-extra {
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 4px;
  margin-bottom: 8px;
}

.file-extra-content {
  padding: 12px 16px;
}

.mtd-collapse-item-header {
  padding-top: 6px;
  padding-bottom: 6px;
}

.mtd-collapse-item-content {
  padding: 0;
}

.file-item-block {
  height: 44px;
  opacity: 0.8;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.20);
  border-radius: 2px;
}

.file-type-icon {
  width: 26px;
  height: 42px;
  text-align: center;
  vertical-align: middle;
  padding-top: 10px;
  float: left;
}

.file-type-icon img {
  height: 22px;
}

.progress-status-container {
  width: calc(100% - 30px);
  height: 42px;
  float: left;
  padding: 5px 0;
}

.progress-status-container .file-name-div {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 14px;
  font-weight: 500;
  width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.progress-status-container .progress-div {
  margin-top: 4px;
  height: 14px;
}

.upload-result-default {
  color: #0A70F5;
}

.upload-result-success,
.upload-result-success .file-upload-progress,
.upload-result-success .file-upload-show-text {
  color: #00B365 !important;
  opacity: 1 !important;
}

.upload-result-fail,
.upload-result-fail .file-upload-progress,
.upload-result-fail .file-upload-show-text {
  color: #DD3429 !important;
  opacity: 1 !important;
}

.progress-status-container .progress-div .mtdicon-bolt-fill {
  float: left;
}

.progress-status-container .progress-div .file-upload-progress {
  width: 75px;
  display: inline-block;
  float: left;
  border: none;
}

.progress-status-container .progress-div .file-upload-show-text {
  opacity: 0.5;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.84);
  font-weight: 500;
  line-height: 14px;
  display: inline-block;
  margin-left: 4px;
  float: left;
}

.delete-file-container {
  width: 30px;
  height: 42px;
  float: right;
  padding: 11px 5px;
}

.delete-file-container .mtd-icon-btn {
  width: 20px;
  height: 20px;
  padding: 0;
}

.submit-buttons-div {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 64px;
  padding: 12px 0;
  text-align: center;
  border-top: 1px #E0E0E0 solid;
  left: 0;
  background-color: #fff;
  z-index: 999;
}

</style>
